module.exports = __webpack_public_path__ + "img/form.f3ed6fee.svg";